/**
 * 模块名称: 信用额度审批列表
 * @author xuxiaobo@372163.com
 */
import React, { useState, useEffect, useRef } from 'react'
import api from '@/api'
import {
  Table,
  Form,
  Button,
  Input,
  Select,
  Row,
  Col,
  Modal,
  DatePicker,
  Icon,
  message,
  Popconfirm,
  Switch,
  Alert
} from 'antd'
import { Link } from 'react-router-dom'
import { parseSearch } from '@/utils'
import Export from '@/components/Export'
import CorpFilter from '@/components/CorpFilter'
import Auth from '@/components/AuthMiddleware'
import moment from 'moment'
import CryptoJS from 'crypto-js'

const { Column } = Table
const FormItem = Form.Item
const Option = Select.Option
const { RangePicker } = DatePicker
let pageSize = 10
let currentPage = 1
let shouldMe = null
let apiOperateTimer = true

let filter = {
  companyId: '',
  oaqId: '',
  cqname: '',
  verifyNumber: '',
  verifyType: '',
  approvalStatus: '',
  proposerName: '',
  addTime: '',
}

let allFilter = {}

let selectedIds = ''
let params = {}

const CreditApply = (props) => {
  const { match, location, history } = props
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue } = props.form
  const productsRef = useRef()
  const [loading, setLoading] = useState(false)
  const [list, setList] = useState([])
  const [count, setCount] = useState(0)
  const [authList, setAuthList] = useState([])
  const search = parseSearch(location.search)
  const [expand, setExpand] = useState(false)
  const [statusVal, setStatusVal] = useState(undefined)
  const [visible, setVisible] = useState(false)
  const [filterContent, setFilterContent] = useState([])
  const [filterInfoValue, setFilterInfoValue] = useState('')
  // const [checked, setChecked] = useState(0)
  const [approvalStatusAll, setApprovalStatusAll] = useState([]) // 审批状态
  const [verifyTypeAll, setVerifyTypeAll] = useState([]) // 真实性号码验证类型
  const [projects, setProjects] = useState([])
  const [statusValName, setStatusValName] = useState(undefined)
  const [flag, setFlag] = useState(false)
  const [shouldMeDis, setShouldMeDis] = useState(true)//风控，防止用户频繁点击switch
  const [showExport, setShowExport] = useState(false)

  useEffect(() => {
    currentPage = search.page ? +search.page : 1
    pageSize = search.pageSize ? +search.pageSize : 10
    filter = {
      companyId: '',
      oaqId: '',
      cqname: '',
      verifyNumber: '',
      verifyType: '',
      approvalStatus: '',
      proposerName: '',
      addTime: '',
    }
    shouldMe = null
    apiOperateTimer = true
    getList()
    onsetApprovalStatus()
    onsetVerifyTypeAll()
    api.getPageAuth().then(list => setAuthList(list))
  }, [])

  const getList = () => {
    if(apiOperateTimer){
      setLoading(true)
      if(shouldMe){
        filter.shouldMe = shouldMe
      }else{
        for(let i in filter){
          if(i == 'shouldMe')delete filter[i]
        }
      }
      api.getCreditApplyList({ ...filter, limit: pageSize, page: currentPage })
      .then(data => {
        setLoading(false)
        setList(data.list)
        setCount(data.count)
        for(var i = 0; i < data.list.length; i++){
          //data.list[i].editFlag = true
          //data.list[i].delFlag = true
        }
      })
      .catch(() => setLoading(false))
      apiOperateTimer = false
      setShouldMeDis(false)
      let timer = setTimeout(() => {
        apiOperateTimer = true
        setShouldMeDis(true)
        clearTimeout(timer)
      }, 1000)
    }else{
      return message.info('请不要频繁操作')
    }
  }

  const onSetShouldMe = e => {
    if(e == true){
      shouldMe = 1
    }else{
      shouldMe = null
    }
    getList()
  }

  const onChangeTable = (pagination, filters, sorter) => {
    currentPage = pagination.current
    pageSize = pagination.pageSize
    history.replace(`${match.path}?page=${currentPage}&pageSize=${pageSize}`)
    getList()
  }

  // 审批状态
  const onsetApprovalStatus = () => {
    api.getAuditStatusList({type: '16'}).then(data => {
      setApprovalStatusAll(data)
    })
  }

  // 真实性号码验证类型
  const onsetVerifyTypeAll = () => {
    api.getCommon({ type: 'verify_type' }).then(data => {
      setVerifyTypeAll(data)
    })
  }

  const onChangePicker = (data) => {
    if (data.length === 0) {
      filter.sTime = ''
      filter.eTime = ''
    } else {
      filter.sTime = moment(data[0]).format('YYYY-MM-DD')
      filter.eTime = moment(data[1]).format('YYYY-MM-DD')
    }
  }

  const onChangeCorp = (data) => {
    filter.companyId = data.map(item => item.id).join(',')
    currentPage = 1
    history.replace(match.path)
    getList()
  }

  // 查询
  const onSearch = (e) => {
    e.preventDefault()
    validateFields((err, vals) => {
      // console.log(vals)
      if (!err) {
        currentPage = 1
        history.replace(match.path)
        const time = {}
        if(vals.addTime){
          time.sTime = moment(vals.addTime[0]).format('YYYY-MM-DD')
          time.eTime = moment(vals.addTime[1]).format('YYYY-MM-DD')
        }
        filter = { ...filter, ...vals, ...time }
        for(let i in params){
          if(params[i] == undefined || i == 'addTime'){
            delete params[i]
          }
        }
        getList()
        // api.getCreditApplyList({ ...params, limit: pageSize, page: currentPage })
        // .then(data => {
        //   setLoading(false)
        //   setList(data.list)
        //   setCount(data.count)
        // })
      }
    })
  }

  const onToggle = () => {
    setExpand(!expand)
  }
  
  const onReset = () => {
    resetFields()
    shouldMe = null
    filter = {
      companyId: filter.companyId,
      oaqId: '',
      cqname: '',
      verifyNumber: '',
      verifyType: '',
      approvalStatus: '',
      proposerName: '',
      addTime: '',
    }
    filter.sTime = ''
    filter.eTime = ''
    setStatusVal(undefined)
    setStatusValName(undefined)
    currentPage = 1
    history.replace(match.path)
    getList()
  }

  const onChecked = (value, val2) => {
    setStatusVal(value)
    setStatusValName(val2.props.children.props.children[0])
    let data = filterContent[value].content
    setFieldsValue({
      companyId: data.companyId ? data.companyId : undefined,
      oaqId: data.oaqId ? data.oaqId : undefined,
      cqname: data.cqname ? data.cqname : undefined,
      verifyNumber: data.verifyNumber ? data.verifyNumber : undefined,
      verifyType: data.verifyType ? data.verifyType : undefined,
      approvalStatus: data.approvalStatus ? data.approvalStatus : undefined,
      proposerName: data.proposerName ? data.proposerName : undefined,
      addTime: data.addTime ? [moment(data.addTime[0], 'YYYY-MM-DD'), moment(data.addTime[1], 'YYYY-MM-DD')] : undefined
    })
  }

  // 筛选删除
  const onSearchDelete = (id) => {
    api.searchStorageDelete({
      id: id
    }).then(() => {
      api.getSearchStorage({ key: location.pathname }).then(data => {
        setFilterContent(data.list)
      })
    })
  }

  const onSaveFilterTerm = () => {
    validateFields((err, vals) => {
      if (!err) {
        const values = Object.values(vals)
        if (values.some(item => item !== undefined)) {
          params = {}
          for (let k in vals) {//eslint-disable-line
            if (vals[k] !== undefined) {
              if (k === 'addTime') {
                params[k] = [moment(vals[k][0]).format('YYYY-MM-DD'), moment(vals[k][1]).format('YYYY-MM-DD')]
              } else {
                params[k] = vals[k]
              }
            }
          }
          setVisible(true)
        } else {
          message.error('当前没有设置筛选条件')
        }
      }
    })
  }

  const onChangeGetFilter = (val) => {
    val ? setFlag(true) : setFlag(false)
    // 下拉框搜索内容
    val && api.getSearchStorage({ key: location.pathname }).then(data => {
      setFilterContent(data.list)
    })
  }

  // 弹出框确定
  const HandleOk = () => {
    api.saveSearchStorage({
      name: filterInfoValue,
      key: location.pathname,
      content: params
    }).then(data => {
      setVisible(false)
      message.success('添加成功')
    })
  }

  const HandleCancel = () => {
    setVisible(false) //弹出框内取消
  }

  const FilterInfoChange = (e) => {
    setFilterInfoValue(e.target.value) //弹框input值
  }

  const onDelete = (id) => {
      api.getCreaditApplyDelete({
      id: id}).then(res => {
          message.success('删除成功')
          for(let i = 0; i<selectedIds.length; i++){
              if(selectedIds[i] === id){
                  selectedIds.splice(i, 1)
                  // setChecked(selectedIds.length)
                  i--
              }
          }
          getList()
      })
  }

  const projectsOption = projects.map((project) => (
    <Option key={project.id}>{project.name}</Option>
  ))  

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    }
  }

  //驳回重提
  const onEdit12 = async (date) => {
    //0信用申请，1信用调整
    if(date.addType == 1){
      history.push('/account/creditapply/edit?id='+date.id+'&customerType='+date.ctype+'&customerId='+date.oaqId+'&accountType='+date.accountType+'&companyId='+date.companyId)
      return false
    }
    else{
      history.push('/account/creditapply/add?id='+date.id+'&customerType='+date.ctype+'&customerId='+date.oaqId)
      return false
    }
  }

  //导出
  const onExportFile = () => {
    setShowExport(true)
    Object.assign(allFilter, filter)
  }

  return (
      <>
      <CorpFilter onChange={onChangeCorp} />
      <Form onSubmit={onSearch} {...formItemLayout} className="ant-advanced-search-formTwo">
        <div className="search-item-wrap">
          <div className="search-item">
          <Row gutter={24}>
            <Col span={8}>
              <FormItem label="OAID/QID">
                {getFieldDecorator('oaqId')(<Input placeholder="请输入" />)}
              </FormItem>
              </Col>

              <Col span={8}>
              <FormItem label="客户名称/代理商名称">
                {getFieldDecorator('cqname')(<Input placeholder="请输入" />)}
              </FormItem>
              </Col>

              <Col span={8}>
              <FormItem label="真实性验证号码">
              {getFieldDecorator('verifyNumber')(<Input placeholder="请输入" />)}
              </FormItem>
              </Col>
          </Row>
          <Row gutter={24}  className={expand ? '' : 'hide'}>
              <Col span={8}>
              <FormItem label="真实性验证号码类型">
                {getFieldDecorator('verifyType')(
                  <Select placeholder="全部"
                    dropdownMatchSelectWidth={false}
                  >
                    {verifyTypeAll.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
                  </Select>
                )}
              </FormItem>
              </Col>

              <Col span={8}>
              <FormItem label="审批状态">
                {getFieldDecorator('approvalStatus')(
                  <Select placeholder="全部"
                    dropdownMatchSelectWidth={false}
                    showSearch={true} 
                    optionFilterProp="children"
                  >
                    {approvalStatusAll.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
                  </Select>
                )}
              </FormItem>
              </Col>

              <Col span={8}>
              <FormItem label="申请人">
              {getFieldDecorator('proposerName')(<Input placeholder="请输入" />)}
              </FormItem>
              </Col>
          </Row>
          <Row gutter={24}  className={expand ? '' : 'hide'}>
              <Col span={10}>
              <FormItem label="申请时间">
                {getFieldDecorator('addTime')(<RangePicker allowClear={false} onChange={onChangePicker} />)}
              </FormItem>
              </Col>
          </Row>
          </div>
          <span className={`expand-btn${expand ? ' show-all' : ''}`} onClick={onToggle} style={{cursor: 'pointer', fontSize: '12px', color: '#1890ff'}}>
            <span>{expand ? '收起' : '展开'} <Icon type={expand ? 'up' : 'down'} /></span>
          </span>
        </div>
        <div className="search-btns">

        <div className={`search-btns ${expand ? '' : 'hide'}`}>
            <h4 className="filter-title">已保存筛选方案：</h4>
            <div className="filter-select">
              <Select
                style={{ display: 'inline-block', width: '160px' }}
                placeholder="请选择"
                value={statusVal}
                onDropdownVisibleChange={(e) => onChangeGetFilter(e)}
                onSelect={onChecked}
                dropdownMatchSelectWidth={false}
              >
                {
                filterContent.map((item, index) =>
                  <Option value={index} key={index}>
                    <div className="closeStyBtn">
                      {item.name}
                      {flag && statusValName !== item.name ? <span className="closeSpan"><Icon style={{ fontSize: '10px', color: '#1890ff' }} type="close" onClick={e => {
                        e.stopPropagation()
                        onSearchDelete(item.id)
                      }} /></span> : null}
                    </div>
                  </Option>
                )
              }
              </Select>
            </div>
            <Button className="filter-savebtn" style={{marginLeft: 8, marginRight: 8}} onClick={onSaveFilterTerm}>保存筛选条件</Button>
          </div>
          <Switch 
            checkedChildren="待审批" 
            unCheckedChildren="待审批" 
            disabled={!shouldMeDis} 
            onClick={onSetShouldMe} 
            className="shouldme-switch-btn" 
            checked={shouldMe ? true : false} 
          />
          <Button onClick={onReset}>重置</Button>
          <Button style={{ marginLeft: 8, marginBottom: 20 }} type="primary" htmlType="submit">查询</Button>
          <Modal
            title="保存筛选条件"
            visible={visible}
            onOk={HandleOk}
            onCancel={HandleCancel}
          >
            <Input placeholder="请输入筛选名称" value={filterInfoValue} onChange={FilterInfoChange} />
          </Modal>
        </div>
      </Form>
      <div className="line"></div>
      <div className="add-wrap">
        <Auth auths={authList} code="export">
          <Button type="primary" icon="upload" onClick={onExportFile} style={{ marginLeft: 15 }}>导出</Button>
        </Auth>
      </div>
      <Export
        show={showExport}
        onCancel={() => {
          setShowExport(false)
          productsRef.current.changeVal()
        }}
        tplUrl="getFortuneCreditAccountChangeExportTpl"
        fieldsUrl="getFortuneCreditAccountChangeTplItems"
        saveUrl="saveFortuneCreditAccountChangeExportTpls"
        exportUrl="exportFortuneCreditAccountExport"
        method="export"
        parame={{ ExportType: 'creditaccount.export', id: selectedIds, ...allFilter }}
        cRef={productsRef}
      />
			<Alert className="corp-count" message={`总共${count}条数据`} type="info" showIcon />
      <Table
        size="small"
        dataSource={list}
        rowKey="id"
        className="table-page"
        loading={loading}
        pagination={{
          pageSize,
          total: count,
          current: currentPage,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
        }}
        scroll={{x: 2200}}
        onChange={onChangeTable}
      >
        <Column title="业务编号"
          dataIndex="creditNo"
          fixed="left"
          width={180} 
          render={(text, record) =>
        <>
          {
            <Link to={`${match.path}/details?id=${record.id}&time=${+new Date()}&sign=${CryptoJS.MD5(record.id+'ad629fddf8b8756d2e72e96ae035a5a4'+(+new Date())).toString()}`}>{text}</Link>
          }
        </>
      } />
        <Column title="客户名称/代理商名称" fixed="left" width={180} dataIndex="cqname" />
        <Column title="OAID/QID" dataIndex="oaqId" />
        <Column title="关联项目" dataIndex="project" />
        <Column title="信用额度" dataIndex="amount" />
        <Column title="使用期限（天）" dataIndex="startDay" />
        <Column title="信用类型" dataIndex="accountTypeName" />
        <Column title="合同号" dataIndex="contractNo" />
        <Column title="申请人" dataIndex="proposerName" />
        <Column title="审批状态" dataIndex="approvalStatus" />
        <Column title="申请时间" dataIndex="addTime" />
        <Column title="审批通过时间" dataIndex="approvaledTime" render={(text, record) =>
        <>
          {text != '0000-00-00 00:00:00' ? text : ''}
        </>
      } />
        <Column title="操作" key="set" fixed="right" width={100} render={(text, record) => (
            <>
                {text.editFlag && <Icon className="operate-icon" style={{ color: '#1890ff' }} type="edit" onClick={() => onEdit12(record)
                }/>}
                {' '}
                {text.delFlag &&
                <Popconfirm title="请确认是否删除？" cancelText="取消" okText="确认" onConfirm={() => onDelete(record.id)}>
                    <Icon className="operate-icon" style={{ color: 'red' }} type="delete"/>
                </Popconfirm>}
            </>
        )}/>
      </Table>
      <div className="line-box"></div>
      </>
  )
}

export default Form.create()(CreditApply)